<template lang="html">
<div class="pgInner declare" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>BANNER</span>
           <div class="btns">
                <!-- <el-button size="mini">刷新</el-button> -->

                <el-button type="primary" size="mini" @click="goEdit('new')">
                      <span>新建</span>
                </el-button>
                
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入内容" @input="reInxList" v-model="listParams.keyword">
                    <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>
      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             v-loading="loading"
             @selection-change="tabSelect"
             style="width: 100%">
             <el-table-column
               type="selection"
               align="center"
               width="30">
             </el-table-column>
             <el-table-column
               prop="name"
               label="标题">
             </el-table-column>

             <el-table-column
               width="240"
               align="center"
               label="跳转类型">
                <template slot-scope="scope">
                     {{ scope.row.type | datFormate(3) }}
                </template>

             </el-table-column>

             <el-table-column
               prop="sort"
               width="60"
               align="center"
               label="排序">
             </el-table-column>

             <el-table-column
               label="状态"
               align="center"
               width="120">
                 <template slot-scope="scope">
                      {{ scope.row.status | datFormate(1) }}
                 </template>
             </el-table-column>

             <el-table-column
               prop="publisher"
               width="120"
               align="center"
               label="操作人">
             </el-table-column>

             <el-table-column
               prop="updatedAt"
               width="180"
               align="center"
               label="更新时间">
             </el-table-column>
             <el-table-column
               label="操作"
               align="center"
               width="180">

               <template slot-scope="scope">

                  <div class="ibtn">
                    <span @click="goEdit('edit',scope.row)">编辑</span>
                    <div class="dvLine"></div>
                  </div>
                  <div class="ibtn">
                    <span @click="goRemove(scope.row)">删除</span>
                    <div class="dvLine"></div>
                  </div>

               </template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <!-- <div class="btns" v-if="listData.length > 0">
                  <el-button @click="changeState(1)" size="mini">上架</el-button>
                  <el-button @click="changeState(2)" size="mini">下架</el-button>
                  <el-button @click="goRemove" size="mini" type="danger">删除</el-button>
              </div> -->


              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-size="allPages"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { bannerList,bannerRemove } from "@/api/banner";
export default {
    filters:{
        datFormate:function(e,type){
            if(type == 1){    // 状态
                var transMap = {
                    1:'已发布',
                    2:'未发布'
                };
                return transMap[e];
            }else if(type == 3){
                var transMap = {
                    1:'H5页面',
                    2:'申报',
                    3:'政策',
                    4:'政务',
                    5:'活动速递',
                    6:'产品集市',
                    7:'服务广场',
                    8:'办公选址',
                    9:'商协会'
                };
                return transMap[e];
            }
        }
    },
    data(){
        return{
            pageH:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,

            listParams:{
              keyword:'',
              type:'',
              status:'',
              sort:2,
              no:1,
              size:12
            },

            allPages:0,
            allEls:0,

            options1:[
               { key:1,name:'发布时间正序' },
               { key:2,name:'发布时间倒序' }
            ],

            options2:[
               { key:1,name:'已发布' },
               { key:2,name:'草稿' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        getList:function(){
            this.loading = true;
            bannerList(this.listParams).then(res => {
                this.listData = res.bannerList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }

            if(this.selectArr.length > 0){
                this.$confirm('确认要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    bannerRemove({ids:this.selectArr}).then(res => {
                        vues.reInxList();
                        vues.selectArr = [];
                    })
                }).catch(() => {
                    vues.selectArr = [];
                });

            }else{
                this.$message.error('请选择删除项！');
            }
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                ancStatusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goEdit:function(type,e){   // 编辑
            var querys = {};
            if(type == 'edit'){
                querys.id = e.id;
            }
            this.$router.push({
                path:'banner_edit',
                query:querys
            });
        },

        tabSelect:function(e){
            var arrs = [];
            e.forEach(item => {
                arrs.push(item.id);
            })
            this.selectArr = arrs;
        },

        selectChange:function(e){    // 类型
            this.listParams.type = e.id;
            this.reInxList();
        },

        handleCurrentChange:function(e){
            this.listParams.no = e;
            this.getList();
        },
        reInxList:function(){
            this.listParams.no = 1;
            this.getList();
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();

            this.getList();


        },
    },
    created:function(){

        this.prevSet();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns{
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.pgbody{
  margin: 20px;
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.declare .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.declare .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>



// WEBPACK FOOTER //
// bannerList.vue?4338ee60